import * as React from 'react';
var BodyContext = /*#__PURE__*/React.createContext(null);
export default BodyContext;